import { render, staticRenderFns } from "./EditAgent.component.vue?vue&type=template&id=4c6a8916&"
import script from "./EditAgent.component.vue?vue&type=script&lang=ts&"
export * from "./EditAgent.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports